<div class="visit-planner vp">
  <header class="vp__head">
    <div class="vp__intro">
      <h2 class="vp__title">Visit Planner</h2>
      <p class="vp__sub">Schedule in-person or video visits. HCPs and attendees get an email with a calendar invitation (.ics).</p>
    </div>
    <div class="vp__actions">
      <button type="button" class="vp__btn vp__btn--secondary" (click)="openPhoneCall()">
        <mat-icon>call</mat-icon>Phone call
      </button>
      <button type="button" class="vp__btn vp__btn--primary" (click)="newVisit()">
        <mat-icon>add</mat-icon>New visit
      </button>
    </div>
  </header>

  <section class="vp__card" [attr.aria-busy]="loading">
    <div class="vp__progress" *ngIf="loading" aria-hidden="true"></div>

    <div class="vp__toolbar">
      <div class="vp__nav">
        <button type="button" class="vp__btn vp__btn--secondary vp__btn--sm" [disabled]="todayInRange" (click)="today()">Today</button>
        <div class="vp__arrows">
          <button type="button" class="vp__icon-btn" aria-label="Previous" title="Previous" (click)="prev()"><mat-icon>chevron_left</mat-icon></button>
          <button type="button" class="vp__icon-btn" aria-label="Next" title="Next" (click)="next()"><mat-icon>chevron_right</mat-icon></button>
        </div>
        <h3 class="vp__range" aria-live="polite">{{ title }}</h3>
      </div>

      <div class="vp__tools">
        <div class="vp__legend" aria-label="Visits in view">
          <span class="vp__legend-item"><i class="vp__dot vp__dot--in-person"></i>In-person<b>{{ inPersonCount }}</b></span>
          <span class="vp__legend-item"><i class="vp__dot vp__dot--video"></i>Video<b>{{ videoCount }}</b></span>
        </div>
        <button type="button" class="vp__switch" role="switch" [attr.aria-checked]="showCancelled" (click)="toggleCancelled()">
          <span class="vp__switch-track"><span class="vp__switch-thumb"></span></span>
          Cancelled<b *ngIf="cancelledCount">{{ cancelledCount }}</b>
        </button>
        <button
          type="button"
          class="vp__icon-btn"
          [class.vp__icon-btn--spin]="loading"
          aria-label="Refresh"
          title="Refresh"
          [disabled]="loading"
          (click)="refresh()"
        >
          <mat-icon>refresh</mat-icon>
        </button>
        <div class="vp__views" role="group" aria-label="Calendar view">
          <button
            *ngFor="let v of views"
            type="button"
            class="vp__view"
            [class.vp__view--on]="v.type === view"
            [attr.aria-pressed]="v.type === view"
            (click)="changeView(v.type)"
          >
            {{ v.label }}
          </button>
        </div>
      </div>
    </div>

    <div class="vp__alert" *ngIf="errorMessage" role="alert">
      <mat-icon fontSet="material-icons-outlined">error</mat-icon>
      <span class="vp__alert-text">{{ errorMessage }}</span>
      <button type="button" class="vp__link" (click)="refresh()">Retry</button>
    </div>
    <div class="vp__hint" *ngIf="emptyRange && view !== 'listWeek'">
      <mat-icon fontSet="material-icons-outlined">event_available</mat-icon>
      No visits this {{ rangeNoun }}. Click a time slot or New visit to schedule one.
    </div>

    <div class="vp__calendar">
      <full-calendar [options]="calendarOptions">
        <!-- Column heads: "TUE 13", today's date in a blue circle (month view: day names only) -->
        <ng-template #dayHeaderContent let-arg>
          <span class="vp-day" [class.vp-day--today]="arg.isToday && arg.view.type !== 'dayGridMonth'">
            <span class="vp-day__name">{{ arg.date | date: "EEE" }}</span>
            <span class="vp-day__num" *ngIf="arg.view.type !== 'dayGridMonth'">{{ arg.date | date: "d" }}</span>
          </span>
        </ng-template>

        <!-- Visit cards: type icon, time, title; cancelled ones struck through -->
        <ng-template #eventContent let-arg>
          <div
            class="vp-ev"
            [class.vp-ev--video]="arg.event.extendedProps.video"
            [class.vp-ev--cancelled]="arg.event.extendedProps.cancelled"
            [class.vp-ev--list]="arg.view.type === 'listWeek'"
            [class.vp-ev--short]="arg.view.type.startsWith('timeGrid') && isShort(arg.event.start, arg.event.end)"
          >
            <span class="vp-ev__time">
              <mat-icon fontSet="material-icons-outlined">{{ arg.event.extendedProps.video ? "videocam" : "place" }}</mat-icon>
              <ng-container *ngIf="arg.view.type !== 'listWeek'">{{
                arg.view.type.startsWith("timeGrid") && isShort(arg.event.start, arg.event.end) ? (arg.event.start | date: "h:mm a") : arg.timeText
              }}</ng-container>
            </span>
            <span class="vp-ev__title">{{ arg.event.title }}</span>
            <span class="vp-ev__where" *ngIf="arg.view.type === 'listWeek' && arg.event.extendedProps.location">{{ arg.event.extendedProps.location }}</span>
            <span class="vp-ev__tag" *ngIf="arg.event.extendedProps.cancelled">Cancelled</span>
          </div>
        </ng-template>

        <ng-template #noEventsContent>
          <div class="vp-empty">
            <mat-icon fontSet="material-icons-outlined">event_available</mat-icon>
            <p class="vp-empty__title">No visits this week</p>
            <p class="vp-empty__text">Use New visit to schedule one.</p>
          </div>
        </ng-template>
      </full-calendar>
    </div>
  </section>
</div>
